export default {
  computed: {
    encodedToken() {
      const token = this.$route.query.token.replace(/\s/g, "+")
      return encodeURIComponent(token)
    }
  }
}